import React, { ReactNode } from 'react';
import parseAspectRatioString from './parseAspectRatioString';
interface Props {
    aspectRatio?: string;
    children: ReactNode;
}

/**
 * Example usage:
 * <FixedAspectRatioDiv aspectRatio={'16:9'}>
 *     <img src={product.image.imageSrc} style={{height:'100%'}}/>
 * </FixedAspectRatioDiv>
 */
const FixedAspectRatioDiv = ({
    aspectRatio = '1:1',
    children,
}: Props) => {
    const aspectRatioObject = parseAspectRatioString(aspectRatio);
    const ratioPercentage = (+aspectRatioObject.height) / (+aspectRatioObject.width) * 100;
    return (
        <div style={{ position: 'relative', width: '100%', paddingTop: ratioPercentage + '%' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }}>
                {children}
            </div>
        </div>
    );
};

export default FixedAspectRatioDiv;
